import React, { useEffect, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import currencies from "../../../lib/currencies/currencies";

export const RectBorder = styled.rect`
  stroke-linecap: round;
  stroke-dasharray: 312.4;
  animation: rectBorderAnim 2s linear both infinite;
  stroke-dashoffset: 0;
  stroke-width: 3px;
  /* @media only screen and (max-width: 374px) {
    stroke-dasharray: 287.8;
    animation: rectBorderAnimS 2s linear both infinite;
  } */
  @keyframes rectBorderAnim {
    0% {
      stroke-dashoffset: 937.2;
    }
    100% {
      stroke-dashoffset: 312.4;
    }
  }
  @keyframes rectBorderAnimS {
    0% {
      stroke-dashoffset: 863.4;
    }
    100% {
      stroke-dashoffset: 287.8;
    }
  }
`;

const btnBackground = keyframes`
 0% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
    33% {
      opacity: 0.5;
      animation-timing-function: cubic-bezier(0.2, 0.1, 0.3, 1);
    }
    66% {
      opacity: 0;
    }
`;

const loadingloop = keyframes`
    0% {
      stroke-dashoffset: 534.7;
      stroke-dasharray: 0, 634.7;
    }
    10% {      
      stroke-dasharray: 124.7, 510;
    }
    50% {
      stroke-dashoffset: -100;
      stroke-dasharray: 124.7, 510;
    }
    100% {
      stroke-dashoffset: -734.7;
      stroke-dasharray: 0, 634.7;
    }
`;

const loadingloopAnim = css`
  ${loadingloop}
`;
const fadeOutAnim = keyframes`
 0% {
   transition-timing-function: cubic-bezier(0.5, 0, 0, 1);
   opacity:1; 
 }
  100%{
     opacity:0; 
   } 
`;

const fadeOut = css`
  ${fadeOutAnim} 83ms forwards 1
`;
const StopFooterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  width: 315px;
  margin: 25px auto;
  position: absolute;
  animation: ${(p) => (p.fadeOut ? fadeOut : null)};
  will-change: transform;
  cursor: pointer;

  .loading-spinner {
    #infinite,
    #background,
    #nonInfinite {
      stroke-width: 3px;
      stroke-linecap: round;
      text-anchor: middle;
    }
    #background {
      stroke: #32075b;
    }

    #infinite {
      stroke: #ffb000;
      stroke-dasharray: 114.7, 500;
      stroke-dashoffset: 534.7;
      animation: ${loadingloopAnim} 4s linear infinite;
    }

    #nonInfinite {
      stroke: #ffb000;
      stroke-dashoffset: -112;
      transition: all ${(p) => p.duration} linear;

      ${(p) =>
        p.myWidth
          ? `stroke-dasharray:  ${p.myWidthReverse} ${p.myWidth}`
          : p.myWidth === 0
          ? "stroke-dasharray:  634.7, 0;"
          : "stroke-dasharray: 0, 634.7;"};

      animation: initAnim;
      animation-duration: ${(p) => p.duration};
      animation-timing-function: linear;

      @keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, (634.7 / ${(p) => p.betTotal});
        }
      }
      @-webkit-keyframes initAnim {
        from {
          stroke-dasharray: 0, 634.7;
        }
        to {
          stroke-dasharray: 0, ${(p) => p.test};
          /* stroke-dasharray: 0, (634.7 / ${(p) => p.betTotal}); */
        }
      }
    }
    #back {
      opacity: 0;
      /* animation: ${(props) => (props.stopA ? btnBackground : null)}; */
      /* animation-duration: 0.5s; */
    }
    #text {
      transform: translateX(158px);
    }
  }

  svg {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  #text {
    font-size: 20px;
    transform: translateX(156px);
  }
  #bet {
    font-size: 12px;
    position: absolute;
    right: 50%;
    transform: translateX(50%) translateY(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffb000;
    svg {
      margin-left: 4px;
      /* margin-bottom: -1px; */
      width: 11px;
      height: 11px;
      path {
        fill: #ffb000;
      }
    }
  }
`;

export const StopFooter = ({
  toggleIsAutoOn,
  bet,
  stopAnim,
  setStopAnimation,
  betCount,
  betTotal,
  fadeOut,
  isFast,
  toFix,
  currency,
  // gameMode,
  // handleStop,
  // isAutoOn,
}) => {
  const [dashWidth, setDashwidth] = useState(null);
  const [dashWidthR, setDashwidthR] = useState(0);
  const [isInfinite, setIsInfinite] = useState(false);
  const [test, setTest] = useState(0);
  const [duration, setduration] = useState("1200ms");

  useEffect(() => {
    setduration(isFast ? "1200ms" : "5000ms");
  }, [isFast]);

  useEffect(() => {
    if (parseInt(betTotal) > 0) {
      setIsInfinite(false);
      if (betCount < parseInt(betTotal) && dashWidth >= 0) {
        setDashwidth(
          634.7 -
            634.7 / parseInt(betTotal) -
            (634.7 / parseInt(betTotal)) * betCount >=
            0
            ? 634.7 -
                634.7 / parseInt(betTotal) -
                (634.7 / parseInt(betTotal)) * betCount
            : 0,
        );
        setDashwidthR(
          634.7 / parseInt(betTotal) + (634.7 / parseInt(betTotal)) * betCount,
        );
        setTest(634.7 / parseInt(betTotal));
      }
    } else {
      setIsInfinite(true);
    }
  }, [dashWidth, betCount, betTotal]);

  return (
    <StopFooterDiv
      stopA={stopAnim}
      myWidth={dashWidth}
      myWidthReverse={dashWidthR}
      duration={duration}
      fadeOut={fadeOut}
      isInf={isInfinite}
      betTotal={betTotal}
      test={test}
      onClick={() => {
        setStopAnimation();
        setTimeout(() => {
          toggleIsAutoOn(false);
        }, 200);
      }}
    >
      <svg style={{ display: "none" }}>
        <defs>
          <symbol id="loopingPath" viewBox="-2 -2 289 60">
            <path
              d="M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z"
              fill="none"
            />
          </symbol>

          <symbol id="back" viewBox="-2 -2 289 60">
            <path
              d="M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z"
              stroke="none"
              fill="#ffffff"
            />
          </symbol>
        </defs>
      </svg>
      <svg className="loading-spinner">
        <use id="background" xlinkHref="#loopingPath" />
        {isInfinite ? (
          <use id="infinite" xlinkHref="#loopingPath" />
        ) : (
          <use id="nonInfinite" xlinkHref="#loopingPath" />
        )}
        <use id="text" xlinkHref="#text" />
        <use id="back" xlinkHref="#back" />
        {/* <text textAnchor="middle" y="46" fontSize="10" fill="#ffb000">
              {(+bet).toFixed(toFix)} {currencies[currency]}
            </text> */}
        <g id="text">
          <text textAnchor="middle" y="30" fontSize="20" fill="#ffb000">
            STOP
          </text>
        </g>
      </svg>
      <p id="bet">
        {(+bet).toFixed(toFix)} {currencies[currency]}
      </p>
    </StopFooterDiv>
  );
};

export const Curr = styled.div`
  path {
    fill: red;
  }
`;
